import { render, staticRenderFns } from "./ExchangeRecords.vue?vue&type=template&id=5a24a06d&scoped=true&"
import script from "./ExchangeRecords.vue?vue&type=script&lang=js&"
export * from "./ExchangeRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24a06d",
  null
  
)

export default component.exports